import { Box, Tooltip, } from "@mui/material";

const ButtonTooltip = ({ children, title }) => (
  <Tooltip
    arrow
    followCursor
    placement="top-start"
    title={title}
    slotProps={{
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8],
            },
          },
        ],
      },
    }}
  >
    <Box component="span">
      {children}
    </Box>
  </Tooltip>
);

export default ButtonTooltip;
